/**
 * Convert any valid CSS color string (e.g. "black", "rgb(0,0,0)") to a
 * hex string (#rrggbb). Returns the original value when running outside
 * a browser or when the value is already a valid hex color.
 */
export function toHexColor(color: string): string {
  const trimmed = color.trim();
  if (/^#[\da-f]{6}$/i.test(trimmed)) return trimmed.toLowerCase();
  if (/^#[\da-f]{3}$/i.test(trimmed)) {
    const [, r, g, b] = trimmed;
    return `#${r}${r}${g}${g}${b}${b}`.toLowerCase();
  }

  if (typeof document === 'undefined') return trimmed;

  const ctx = document.createElement('canvas').getContext('2d');
  if (!ctx) return trimmed;
  ctx.fillStyle = '#000000';
  ctx.fillStyle = trimmed;
  const resolved = ctx.fillStyle;
  if (resolved.startsWith('#')) return resolved.toLowerCase();

  // ctx.fillStyle may return an rgb() string
  const match = /^rgba?\((\d+),\s*(\d+),\s*(\d+)/.exec(resolved);
  if (match) {
    const hex = (n: string) => Number(n).toString(16).padStart(2, '0');
    return `#${hex(match[1])}${hex(match[2])}${hex(match[3])}`;
  }
  return trimmed;
}
